import React from "react";
import EnergyAssetsCard from "./EnergyAssetsCard";

const HydroPower = ({ energyAssetsData }) => {
  const hydroPowerPlants = energyAssetsData.filter(
    (plant) => plant.field_category_page_assets === "Hydro Power"
  );

  // Check if there are no hydro power plants
  if (hydroPowerPlants.length === 0) {
    return <div>No hydro power plants available</div>;
  }

  return (
    <div className="hydro-power-box1b aos-init aos-animate">
      <ul>
        {hydroPowerPlants
          // .filter((item) => item.field_status === "Completed")
          .map((item, index) => (
            <EnergyAssetsCard plantData={item} key={index} />
          ))}
      </ul>
    </div>
  );
};

export default HydroPower;
